<template>
  <div class="video">
    <div class="btnbox" @click="addVideo">
      <el-button class="add-btn" icon="el-icon-plus">添加教程</el-button>
    </div>
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="tutorialName" label="教程名称">
        </el-table-column>
        <el-table-column label="视频文件">
          <template slot-scope="{ row }">
            <el-button class="textBlue-btn" @click="goCheck(row.fileUrl)"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间"> </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="120">
          <template slot-scope="{ row }">
            <el-button
              class="textOrange-btn"
              style="margin-right: 10px"
              @click="editVideo(row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="是否删除该教程视频？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(row.id)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加视频 -->
    <el-dialog
      :visible.sync="addVisible"
      :before-close="handleClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>{{ type === "add" ? "添加" : "修改" }}教程视频</p>
        <span @click="handleClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-content">
        <el-form
          :model="tutorialForm"
          :rules="tutorialRules"
          ref="tutorialForm"
          class="demo-tutorialForm"
          label-position="left"
          label-width="150px"
        >
          <el-form-item label="教程名称：" prop="tutorialName">
            <el-input
              v-model="tutorialForm.tutorialName"
              placeholder="请输入教程名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="教程语言：" prop="language">
            <el-select
              v-model="tutorialForm.language"
              placeholder="请选择教程语言"
            >
              <el-option
                v-for="item in getDictDatas(DICT_TYPE.LANGUAGE)"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传视频：" prop="fileUrl">
            <upload-img
              accept="video/*"
              upload-name="上传视频"
              tip="支持MP4/MOV/AVI格式，最大100MB"
              @uploadInfo="handleVideoUpload"
              fileDir="tutorial"
              :resultFile="tutorialForm.fileUrl"
            />
          </el-form-item>
          <el-form-item class="handlebox" label=" ">
            <el-button
              type="primary"
              @click="submitForm('tutorialForm')"
              class="enter-btn save-btn"
              :loading="submitLoading"
              >保存</el-button
            >
            <el-button
              @click="resetForm('tutorialForm')"
              class="cancel-btn calloff-btn"
              >取消</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 查看视频 -->
    <el-dialog
      :visible.sync="checkVisible"
      title="查看教程视频"
      :before-close="handleCheckClose"
      destroy-on-close
      :show-close="false"
      width="40%"
    >
      <div slot="title" class="title">
        <p>查看教程视频</p>
        <span @click="handleCheckClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="video-content">
        <video
          :src="videoUrl"
          controls
          class="video-player"
          ref="videoPlayer"
        ></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTutorialList,
  setGameTutorial,
  deleteGameTutorial,
} from "@/api/unity";
import UploadImg from "../../../components/UploadImg";
export default {
  components: { UploadImg },
  data() {
    return {
      tableData: [],
      gameId: "",
      addVisible: false,
      tutorialForm: {
        language: "",
        gameClassify: 0,
        fileUrl: "",
        tutorialName: "",
      },
      tutorialRules: {
        language: [
          { required: true, message: "请选择教程语言", trigger: "change" },
        ],
        fileUrl: [
          { required: true, message: "请上传教程文件", trigger: "blur" },
        ],
        tutorialName: [
          { required: true, message: "请输入教程名称", trigger: "blur" },
        ],
      },
      submitLoading: false,
      videoUrl: "",
      checkVisible: false,
      videoItem: {},
      type: "add",
    };
  },
  created() {
    this.gameId = this.$route.query.id;
    this.init();
  },
  mounted() {},
  methods: {
    //获取教程视频列表
    async init() {
      const res = await getTutorialList({
        gameClassify: 0,
        gameId: this.gameId,
      });
      // console.log(res);
      this.tableData = res.result;
      //   this.total = res.result.total;
    },
    // 删除
    async deleteFn(id) {
      await deleteGameTutorial({ id });
      this.$message.success("删除成功");
      this.init();
    },
    handleClose() {
      this.addVisible = false;
    },
    // 添加
    addVideo() {
      this.type = "add";
      this.addVisible = true;
    },
    handleVideoUpload(fileUrl) {
      console.log(fileUrl);
      this.tutorialForm.fileUrl = fileUrl;
    },
    // 添加教程视频
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          this.tutorialForm.gameId = this.gameId;
          await setGameTutorial(this.tutorialForm);
          this.submitLoading = false;
          this.$message.success("设置成功！");

          this.resetForm(formName);
          this.init();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      // console.log(formName);
      this.$refs[formName].resetFields();
      this.handleClose();
    },
    // 查看视频
    goCheck(url) {
      this.videoUrl = url;
      this.checkVisible = true;
    },
    handleCheckClose() {
      this.checkVisible = false;
    },
    // 编辑教程
    editVideo(item) {
      this.videoItem = item;
      this.tutorialForm = item;
      this.tutorialForm.gameClassify = 0;
      this.type = "edit";
      this.addVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.video {
  position: relative;
  > .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .video-content {
    display: flex;
    align-items: center;
    justify-content: center;
    /* 新增视频播放器样式 */
    .video-player {
      max-width: 100%;
      max-height: 500px;
      display: block;
      border-radius: 4px;
      background: #000;
    }
  }
  ::v-deep .demo-tutorialForm {
    width: 80%;
    .el-form-item {
      display: flex;
      align-items: center;
    }
    .el-form-item__label {
      white-space: nowrap;
      width: 120px !important;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
    }
    .el-form-item__content {
      width: 0;
      flex: 1;
      margin: 0 !important;
    }
    .handlebox {
      // text-align: right;
      margin-top: 50px;
    }
    // .el-input {
    //   width: 380px;
    // }
  }
}
</style>
